import type { SupplierOrderDto } from '../../dto/supplierOrder';
import { formatUnit } from '../../utils/units';

export function getSupplierOrderLinkItemNames(record: SupplierOrderDto): string[] {
  if (record.itemAllocations?.length) {
    return record.itemAllocations.map((allocation) => (
      allocation.supplierOrderItemName || allocation.orderProductName || '—'
    ));
  }

  return record.supplierOrderItemName ? [record.supplierOrderItemName] : [];
}

export function getSupplierOrderLinkQuantityLabels(
  record: SupplierOrderDto,
  locale = 'pl-PL',
): string[] {
  if (record.itemAllocations?.length) {
    return record.itemAllocations.map((allocation) => (
      `${Number(allocation.allocatedQuantity).toLocaleString(locale, { maximumFractionDigits: 3 })} ${formatUnit(allocation.allocatedUnit, locale)}`
    ));
  }

  if (!record.allocatedQuantity) return [];

  const unit = record.allocatedUnit || record.supplierOrderItemUnit;
  return [`${Number(record.allocatedQuantity).toLocaleString(locale, { maximumFractionDigits: 3 })} ${formatUnit(unit, locale)}`];
}
